import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, enableProdMode } from '@angular/core'; 
import { AppSettingsService } from './appsettings/appsettings.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { UiModule } from './ui/ui.module';
import { UserModule } from './user/user.module';
import { ReportingModule } from './reporting/reporting.module';
import { ShippingModule } from './shipping/shipping.module';

import { HomeComponent } from './home/home.component';
import { AuthService } from './auth/auth.service';
import { ReportingService } from './reporting/services/reporting.service';
import { PatientService } from './reporting/services/patient.service';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'; 
import { ToastrModule } from 'ngx-toastr'; 
import { appRoutes } from './routes'; 
import { CookieService } from 'ngx-cookie-service';
import { AuthGuard } from './auth/auth.guard'; 
import { AuthInterceptor } from './auth/auth.interceptor'; 
import { ProfileService } from './user/profile/profile.service';
import { DelegationComponent } from './delegation/delegation.component';
import { environment } from 'src/environments/environment';

import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

const appInitializerFn = (appConfig: AppSettingsService) => {
  return () => {
      return appConfig.loadAppSettings();
  }
};

console.log(location.protocol);
console.log("Environment Name: ", environment.name);

if (environment.production || location.protocol === "https:")
{
  environment.production = true;
  console.log('Enabling Prod Mode');
  enableProdMode();
}
else
{
  console.log("IsProdBuild: ", environment.production);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DelegationComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    Ng4LoadingSpinnerModule.forRoot(),
    UiModule,
    UserModule,
    ReportingModule,
    ShippingModule
  ],
  providers: 
  [
    AppSettingsService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppSettingsService]
    },
    ProfileService, ReportingService, PatientService, CookieService, AuthService, AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
